import { Button } from "@/components/ui/button";
import { gbp, miles } from "@/lib/api";
import { conditionText } from "./ConditionSlider";

export const cleanName = (d) => {
  const w = (d || "").replace(/\s*\[.*?\]\s*/g, " ").replace(/\s+/g, " ").trim().split(" ");
  for (let n = Math.floor(w.length / 2); n >= 2; n--) {
    for (let i = 0; i + n <= w.length; i++) {
      const seq = w.slice(i, i + n).join(" ").toUpperCase();
      for (let j = i + n; j + n <= w.length; j++) {
        if (w.slice(j, j + n).join(" ").toUpperCase() === seq) { w.splice(j, n); j--; }
      }
    }
  }
  return w.join(" ");
};
const yearFrom = (details = []) => details.find((d) => d.label === "Year")?.value || details.find((d) => d.label === "First registered")?.value?.slice(0, 4);

export const VehicleSummary = ({ v }) => {
  const name = cleanName(v.vehicle?.description);
  const year = yearFrom(v.vehicle?.details);
  return (
    <div className="space-y-1 text-slate-800" data-testid="vehicle-summary">
      {name && <p className="text-lg font-semibold text-slate-900" data-testid="result-vehicle-description">{year ? `${year} ` : ""}{name}</p>}
      <p className="text-sm">Registration: <span className="font-semibold" data-testid="result-registration">{v.registration}</span></p>
      <p className="text-sm">Mileage: <span className="font-semibold" data-testid="result-mileage">{miles(v.mileage)}</span></p>
      {v.condition && <p className="text-sm">Condition: <span className="font-semibold" data-testid="result-condition">{v.condition}/10 · {conditionText(v.condition)[0]}</span></p>}
    </div>
  );
};

export const EstimateCard = ({ v, onChange, onContinue }) => {
  const e = v.estimate;
  return (
    <div className="fade-in" data-testid="estimate-result">
      <p className="text-sm font-semibold uppercase tracking-[0.12em] text-slate-600" data-testid="estimate-kind">Your Estimated Valuation</p>
      <p className="mt-2 text-5xl font-bold tracking-tight text-brand-navy" data-testid="estimate-amount">
        {e.low && e.high ? `${gbp(e.low)} – ${gbp(e.high)}` : gbp(e.amount)}
      </p>
      <div className="mt-6 border-t border-border pt-5"><VehicleSummary v={v} /></div>
      <p className="mt-5 text-sm text-slate-600" data-testid="estimate-initial-label">An indicative estimate, not a guaranteed offer. Subject to inspection and vehicle history checks.{v.mode === "sandbox" && <span className="mt-1 block text-xs text-slate-500" data-testid="estimate-demo-indicator">Demo valuation</span>}</p>
      <Button size="lg" className="btn-cta mt-5 h-12 w-full text-base" onClick={onContinue} data-testid="continue-with-my-car-button">Continue</Button>
      <button type="button" onClick={onChange} className="mt-3 block w-full text-center text-sm text-slate-600 underline-offset-4 hover:text-slate-900 hover:underline" data-testid="change-details-button">
        Change details
      </button>
    </div>
  );
};
